import React from "react";
import { SovosBox, SovosTypography } from "mosaic-react";
import { AutoAwesome } from "mosaic-react-icons";

// Small inline badge shown next to a value that Sovi (AI) suggested, so the
// confidence level stays visible in the field itself instead of only living
// in a one-off review dialog/toast.
const AiConfidencePill = ({ score }) => {
    if (score == null) return null;
    const pct = Math.round(score * 100);

    return (
        <SovosBox
            title="Suggested by Sovos Intelligence"
            sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.375,
                px: 0.75,
                py: 0.25,
                borderRadius: 4,
                bgcolor: "#FCE7F3",
                flexShrink: 0,
                whiteSpace: "nowrap",
            }}
        >
            <AutoAwesome sx={{ fontSize: 12, color: "#BE185D" }} />
            <SovosTypography sx={{ fontSize: 10, color: "#BE185D", fontWeight: 600 }}>
                {pct}%
            </SovosTypography>
        </SovosBox>
    );
};

export default AiConfidencePill;
